<template>
<div class="myIndex page_shopCenter">
    <div class="userInfo">
        <!-- 个人信息 -->
        <div class="user">
            <div class="user_top">
                <div class="user_left" v-if="info">
                    <div class="thumb">
                        <img :src=" info.thumb ? ($publicData.withHttpStart(info.thumb) ? info.thumb : imageUrl+info.thumb) : $publicData.defaultTouxiang" alt />
                    </div>
                    <div class="user_name slh_s">{{ info.company }}</div>
                </div>
                <div class="user_right" v-if="info.userdata">余额:￥{{ info.userdata.useraccount.seller_money ? info.userdata.useraccount.seller_money : 0}}</div>
            </div>
            <!-- 收藏 关注 粉丝 -->
            <div class="mark">
                <div class="item" @click="goDevelop">
                    <div class="num">0</div>
                    <div class="txt">收藏</div>
                </div>
                <div class="item" @click="goDevelop">
                    <div class="num">0</div>
                    <div class="txt">关注</div>
                </div>
                <div class="item" @click="goDevelop">
                    <div class="num">0</div>
                    <div class="txt">粉丝</div>
                </div>
            </div>
            <!-- <div class="mark">
                <div class="item" @click="goPage('collect-index')">
                    <div class="num" v-if="info.nums">{{info.nums.collect}}</div>
                    <div class="txt">收藏</div>
                </div>
                <div class="item" @click="goPage('follow-index')">
                    <div class="num" v-if="info.nums">{{info.nums.attention}}</div>
                    <div class="txt">关注</div>
                </div>
                <div class="item" @click="goPage('fans-index')">
                    <div class="num" v-if="info.nums">{{info.nums.attentioner}}</div>
                    <div class="txt">粉丝</div>
                </div>
            </div> -->
        </div>
    </div>
    <!--  -->
    <div class="con">
        <!-- 订单 -->
        <div class="order" :name="ordertab">
            <div class="top">
                <div class="tabs">
                    <span class="tab active" name="a">商城订单</span>
                </div>
                <span class="more" @click="orderList(0)">全部订单</span>
            </div>
            <div class="nr">
                <div class="txt active" name="a">
                    <ul class="actions">
                        <li class="item" @click="orderList(1)">
                            <img :src="this.publicPath+'statics/images/my/icon_wallet.png'" class="item_icon" alt="">
                            <div class="item_txt">待支付</div>
                            <div class="num" v-if="token && unpay_num!=0">{{unpay_num}}</div>
                        </li>
                        <li class="item" @click="orderList(2)">
                            <img :src="this.publicPath+'statics/images/my/icon_fahuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待发货</div>
                            <div class="num" v-if="token && unship_num!=0">{{unship_num}}</div>
                        </li>
                        <li class="item" @click="orderList(3)">
                            <img :src="this.publicPath+'statics/images/my/icon_shouhuo.png'" class="item_icon" alt="">
                            <div class="item_txt">待收货</div>
                            <div class="num" v-if="token && unreceipt_num!=0">{{ unreceipt_num }}</div>
                        </li>
                        <li class="item" @click="orderList(4)">
                            <img :src="this.publicPath+'statics/images/my/icon_comment.png'" class="item_icon" alt="">
                            <div class="item_txt">待评论</div>
                            <!-- <div class="num">12</div> -->
                        </li>
                        <!-- <li class="item" @click="orderList(5)">
                            <img :src="this.publicPath+'statics/images/my/icon_aftersale.png'" class="item_icon" alt="">
                            <div class="item_txt">售后</div>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
		<!-- 统计 -->
		<div class="list">
			<div class="title">统计</div>
			<div class="list_con tj">
				<div class="list_item">未完成订单金额统计： ￥{{ good_order_price }}</div>
			</div>
		</div>
        <!-- 平台服务 -->
        <div class="list">
            <div class="title">店铺管理</div>
            <ul class="list_con clearfix">
                <li class="item f-l" @click="goPage('btob-center')">
                    <img :src="this.publicPath+ 'statics/images/my/center/01.png'" alt="" class="icon">
                    <div class="txt">账户中心</div>
                </li>
                <li class="item f-l" @click="goPage('seller-goods')">
                    <img :src="this.publicPath+ 'statics/images/my/center/02.png'" alt="" class="icon">
                    <div class="txt">商品管理</div>
                </li>
                <li class="item f-l" @click="goPage('seller-shopset')">
                    <img :src="this.publicPath+ 'statics/images/my/center/05.png'" alt="" class="icon">
                    <div class="txt">店铺设置</div>
                </li>
            </ul>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "my-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            ordertab: 'a',
            publicPath: process.env.BASE_URL,
            info: {}, // 用户信息
			token: null,
			unpay_num: null, // 待支付订单数量
            unreceipt_num: null, // 待收货订单数量
			unship_num: null, // 待发货订单数量
			good_order_price: 0 // 未完成订单金额统计
        };
    },
    created: function () {
		localStorage.removeItem('shopOrderStatus')
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            //加载用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    mounted: function () {

    },
    methods: {
        getData() {
            var param = {
                token: this.token
            }
            // 供应商
            this.$api.my.btobInfo(param).then(res => {
                if (res.code == 200) {
					this.info = res.result.info
					this.good_order_price = res.result.good_order_price;
					var ordernum = res.result.info.ordernums
					this.unpay_num = ordernum.unpay_num.toString().length > 2 ? ordernum.unpay_num.toString().slice(0, 2) + '..' : ordernum.unpay_num.toString()
                    this.unreceipt_num = ordernum.unreceipt_num.toString().length > 2 ? ordernum.unreceipt_num.toString().slice(0, 2) + '..' : ordernum.unreceipt_num.toString()
                    this.unship_num = ordernum.unship_num.toString().length > 2 ? ordernum.unship_num.toString().slice(0, 2) + '..' : ordernum.unship_num.toString()
                }
            })
        },
        // 查看订单
        orderList(status) {
            if (this.isClient) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/tradesman/order?status=' + status + '&sorce=' + (this.ordertab == 'a' ? '0' : '1')+'&uuid='+this.info.uuid+'&is_platprice=1'
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/tradesman/order',
                    query: {
                        status: status,
                        sorce: 0, // 商城订单
                        is_platprice: '1'
                    }
                })
            }
        },
        // 页面跳转
        goPage(name) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        name = name.replace("-", "/")
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl +'/' + name
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                if (!this.$store.getters.token) {
                    this.$router.push({
                        path: '/login',
                        query: {
                            redirect: this.$router.currentRoute.fullPath
                        }
                    })
                    return
                }
                this.$router.push({
                    name: name
                })
            }
		},
		// 开发中
		goDevelop(){
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    'data': {}
                }
                this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                    if (data.code == 200) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl +'/system/develop' 
                            }
                        }
                        console.log(params)
                        console.log('sdjy://public/openNewWebView')
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    }
                })
            } else {
                this.$router.push({
                    path: '/system/develop'
                })
            }
			
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
